import { WithRouterProps } from "next/dist/client/with-router";
import { withRouter } from "next/router";
import { memo, useCallback, useState } from "react";
import { doTimes } from "../../util";
/** @ts-ignore */
import s from './index.module.css'

export interface PagerProps {
  current: number
  total: number
  buttonSize: number
  onChange?: (current: number, total: number) => void
}

const Pager = memo(function Pager(props: PagerProps) {
  let current = props.current
  let total = Math.max(props.current, props.total)
  let buttonSize = props.buttonSize

  if (!isFinite(current)) {
    current = 1
  }
  if (!isFinite(total)) {
    total = 0
  }
  if (!isFinite(buttonSize)) {
    buttonSize = 5
  }

  const getNodes = () => {
    let startPage: number
    let endPage: number
    
    const halfSize = Math.floor(buttonSize / 2)

    const ret: Array<{ type: string, value: any }> = []
    if (current > total - halfSize) {
      startPage = Math.max(total - buttonSize + 1, 1)
      endPage = total
    } else if (current < halfSize) {
      startPage = 1
      endPage = Math.min(total, buttonSize)
    } else {
      startPage = Math.max(1, current - Math.floor(buttonSize / 2))
      endPage = Math.min(startPage + buttonSize, total + 1)
    }
    if (current !== 1) {
      ret.push({
        type: 'prev',
        value: Math.max(1, current - 1)
      })
    }
    if (startPage !== 1) {
      ret.push({
        type: 'prevPage',
        value: Math.max(1, current - buttonSize)
      })
    }
    const mark = ret.length

    if (endPage !== total) {
      ret.push({
        type: 'nextPage',
        value: Math.min(total, current + buttonSize)
      })
    }

    if (current !== total) {
      ret.push({
        type: 'next',
        value: Math.min(total, current + 1)
      })
    }

    ret.splice(mark, 0, ...doTimes(startPage, endPage - startPage + 1, (i) => {
      return {
        type: 'page',
        value: i
      }
    }))
    return ret
  }

  const renderChild = () => {
    return getNodes().map((item) => {
      const classNames = [s['page-box']]
      let key = item.type
      let text = item.value


      if (item.type !== 'page') {
        if (item.type === 'prev') {
          text = <span className={s.prevarrow}></span>
          classNames.push(s['prev'])
        } else if (item.type === 'next') {
          text = <span className={s.nextarrow}></span>
          classNames.push(s['next'])
        } else if (item.type === 'prevPage' || item.type === 'nextPage') {
          text = '...'
        }
        classNames.push(s['func'])
      } else {
        key += '.' + item.value
        if (current === item.value) {
          classNames.push(s['current'])
        }
      }

      return <div className={classNames.join(' ')} key={key} onClick={() => {
        if (current !== item.value) {
          if (props.onChange) {
            props.onChange(item.value, total)
          }
        }
      }}>
        <div>{text}</div>
      </div>
    })
  }





  return <div className={s['page-container']}>
    {renderChild()}
  </div>
});

export default Pager

export const PagerWithRouter = withRouter(({ router, onChange, ...props }: PagerProps & WithRouterProps) => {
  return <Pager {...props} onChange={(current, total) => {
    if (onChange) {
      onChange(current, total)
      router.push({
        query: {
          ...router.query,
          page: current
        }
      })
    }
  }} />
})


export function usePager(initPage = 1, initTotal = 1) {
  if (initPage > initTotal) {
    initTotal = initPage
  }
  initTotal = Math.ceil(initTotal)
  const [currentPage, setCurrentPage] = useState(initPage)
  const [totalPage, setTotal] = useState(Math.ceil(initTotal))
  const setToalMemoied = useCallback((val: number) => {
    setTotal(Math.ceil(val))
  }, [])
  const setCurrentMemoied = useCallback((val: number) => {
    setCurrentPage(val)
    if (val > totalPage) {
      setToalMemoied(val)
    }
  }, [])
  return {
    currentPage,
    totalPage,
    setCurrentPage: setCurrentMemoied,
    setTotal: setToalMemoied
  }
}